// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./themes/inspinia/js/plugins/imagePicker/image-picker.css
// module id = 1300
// module chunks = 0